import Vue from 'vue'

import { addCustomWidgetSchema } from '@/components/form-designer/widget-panel/widgetsConfig'
// 注册属性设置组件
import * as PERegister from '@/components/form-designer/setting-panel/propertyRegister'
// 生成组件属性设置
import * as PEFactory from '@/components/form-designer/setting-panel/property-editor-factory'

import officeTree from "@/extension/office-tree"

addCustomWidgetSchema({
  type: 'officeTree',
  icon: 'alert',
  formItemFlag: true,
  options: {
    name: '', // 唯一名称
    defaultValue: null, // 默认值
    label: '机构',
    labelAlign: 'label-right-align',
    columnWidth: '200px',
    labelWidth: '110',
    required: false,
    disabled: false,
    labelHidden: false,
    clearable: true,
    size: '',
    //-------------------
    placeholder: '请选择',//输入提示文字
    customClass: '',
    isAll: 1,
    //选择项改变事件
    onChange: '',
    getSelectNode: '',
  }
})  //加载组件Json Schema

Vue.component(officeTree.name, officeTree)  //注册组件

// 注册属性编辑框

PERegister.registerCPEditor('isAll', 'isAll-editor',
  PEFactory.createInputNumberEditor('isAll', '查询全部'))


PERegister.registerEPEditor('getSelectNode', 'getSelectNode-editor',
  PEFactory.createEventHandlerEditor('getSelectNode', ['selectNode']))






